import { lazy } from "react";

import { RoutePathBuilder } from "@/common/builders/routePath";
import AuthorizedRoute from "@/common/components/Auth/AuthorizedRoute";
import { Loadable } from "@/common/components/Loadable";
import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission } from "@/core/api/generated/v1";

const EntityViewResolverPage = Loadable(
  lazy(() =>
    import("../../MainAppView/Entities/EntityViewResolverPage").then((module) => ({
      default: module.EntityViewResolverPage,
    })),
  ),
);

export function EntityRoutes() {
  return (
    <>
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.ENTITY_VIEW_RESOLVER())}
        render={() => <EntityViewResolverPage />}
      />
    </>
  );
}
